const utils = require('../../utils')
import AppHeader from '../AppHeader'
import SubMenu from '../SubMenu'
import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'propose-rejected-list',
  created () {
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      isScrollDoneFlag: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  updated () {
    const wr = $('.wrapper')
    if (wr.height() !== 112 && wr.height() !== 186 && wr.height() < $(window).height() && this.searchCallbackFlag === true) {
      wr.height($(window).height())
    }
    if (window.sessionStorage.getItem('propose_list_scroll_top') && this.searchCallbackFlag === true) {
      const data = JSON.parse(window.sessionStorage.getItem('propose_list_scroll_top'))
      if (data['path'] === this.$router.history.current.path) {
        $(window).scrollTop(data['scrollTop'])
        // 自動スクロール後の手動スクロールイベントの発生でセッションからスクロール情報を削除する。そのためのフラグ。
        this.isScrollDoneFlag = true
      }
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    const $win = $(window)
    $win.on('load scroll', function () {
      $('.submenu__list').removeClass('gheader-fix')
      $('.wrapper').css('margin-top', 0)
    })
    if (to.name === 'proposeRejectedDetail') {
      const savedata = {
        'path': this.$router.history.current.path,
        'scrollTop': $(window).scrollTop()
      }
      window.sessionStorage.setItem('propose_list_scroll_top', JSON.stringify(savedata))
    } else {
      window.sessionStorage.removeItem('propose_list_scroll_top')
    }
    next()
  },
  computed: {
    proposes () {
      return this.$store.getters.proposeList
    },
    getRejectedCount () {
      return this.proposes.length
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader,
    SubMenu
  },
  methods: {
    search: function () {
      const url = null
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
      }
      const data = {
        'user_id': window.localStorage.getItem('user_id'),
        'propose_status': 'rejected'
      }
      this.$store.dispatch('PROPOSE_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    getRejectReasonContent: function (rejectReasonContent) {
      const stringMaxLength = 73
      if (!utils.isBlank(rejectReasonContent) && (rejectReasonContent.length > stringMaxLength)) {
        rejectReasonContent = rejectReasonContent.substring(0, stringMaxLength)
      }
      return rejectReasonContent ? this.content(rejectReasonContent) + '<br><span>…もっと見る</span>' : ''
    },
    goProposeDetail: function (proposeId) {
      this.$router.push({ path: '/propose_rejected/' + proposeId })
    },
    goProposeNew: function () {
      this.$router.push({ path: '/propose/new' })
    },
    goProposeEdit: function (proposeId) {
      this.$router.push({path: '/propose/' + proposeId + '/edit'})
    },
    onDeleted: function (result) {
      const button = document.getElementById('proposeDeletedModalButton')
      button.click() // モーダル表示 イベント発火
    },
    goProposeDelete: function (proposeId) {
      this.$store.dispatch('PROPOSE_DELETE', {id: proposeId, callback: this.onDeleted})
    },
    goProposeRejectedList: function () {
      this.$router.push({ path: '/propose_rejected_list' })
      window.location.reload(false)
    },
    onModalClose: function () {
      $('#proposeDeletedModal').modal('hide')
      this.goProposeRejectedList()
    },
    short: function () {
      if (this.proposes.length > 0) {
        return ''
      } else {
        return 'short-contents'
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    handleScroll () {
      if (this.isScrollDoneFlag) {
        window.sessionStorage.removeItem('propose_list_scroll_top')
        this.isScrollDoneFlag = false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-rejected-list.js